import { Show } from "shared/components";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { DecisionAction } from "shared/types";
import { cx } from "shared/utils";
import { ApplicationStatus } from "shared/types";
import { track } from "shared/telemetry/track";
import { useParams } from "react-router-dom";

const recommendationDisplay: Record<
  DecisionAction,
  { text: string; styles: string }
> = {
  [DecisionAction.Approve]: {
    text: "Approve application",
    styles: "bg-success-500 hover:bg-success-600"
  },
  [DecisionAction.Decline]: {
    text: "Decline application",
    styles: "!bg-danger-500 !hover:bg-danger-600"
  },
  [DecisionAction.ConditionalApprove]: {
    text: "Conditionally approve application",
    styles: "bg-warning-500 hover:bg-warning-600"
  }
};

const defaultRecommendationDisplay = { text: "Make decision", styles: "" };

export const RecommendationButton = ({
  recommendation,
  onClickMakeDecision,
  onClickExplainRecommendation,
  canMakeDecision,
  hasReasons = false,
  autoApproved
}: {
  recommendation?: DecisionAction;
  onClickMakeDecision: () => void;
  onClickExplainRecommendation?: () => void;
  canMakeDecision?: boolean;
  className?: string;
  hasReasons?: boolean;
  status?: ApplicationStatus;
  autoApproved?: boolean;
}) => {
  const { applicationId } = useParams();

  const { text, styles } = recommendation
    ? recommendationDisplay[recommendation]
    : defaultRecommendationDisplay;

  return (
    <div className="space-y-2 w-full">
      <Show if={canMakeDecision}>
        <Button
          className={cx("w-full", styles)}
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          onClick={onClickMakeDecision}
          disabled={!canMakeDecision}
        >
          {text}
        </Button>
      </Show>

      <Show if={hasReasons}>
        <Button
          onClick={() => {
            track("application.explain_recommendation.page_view", {
              application_id: String(applicationId),
              recommendation,
              is_auto_approved: autoApproved
            });
            onClickExplainRecommendation?.();
          }}
          size={ButtonSize.SM}
          className="w-full"
        >
          Explain {autoApproved ? "decision" : "recommendation"}
        </Button>
      </Show>
    </div>
  );
};
